/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=3dc8f2e3&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=3dc8f2e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc8f2e3",
  null
  
)

export default component.exports